import { isIOSPWA } from './browser'

// This app never scrolls the document: html and body are overflow:hidden
// (public/css/app.css) and no code scrolls the window. iOS still moves it in
// two cases. Revealing a focused input under the keyboard is legitimate and is
// undone on blur. The other is a WebKit fault: iOS 27 public beta 6 leaves a
// home screen web app scrolled by the status bar height (window.scrollY and
// visualViewport.offsetTop both 59 on an iPhone 15) after rotating away from
// and back to portrait.

const EDITABLE = 'input, textarea, select, iframe'

const hasEditableFocus = () => {
    const active = document.activeElement
    return (
        active instanceof HTMLElement &&
        (active.matches(EDITABLE) || active.isContentEditable)
    )
}

export const resetStrayDocumentScroll = () => {
    const offset = window.visualViewport?.pageTop || window.scrollY
    if (offset <= 0 || hasEditableFocus()) return
    window.scrollTo({ top: 0, left: window.scrollX, behavior: 'instant' })
}

const pending = { frame: 0 }

// Coalesce the burst of scroll/resize events a rotation or keyboard produces
// into one check, after the frame in which the viewport settled.
const scheduleReset = () => {
    if (pending.frame) return
    pending.frame = requestAnimationFrame(() => {
        pending.frame = 0
        resetStrayDocumentScroll()
    })
}

export const installIOSPWAScrollRecovery = () => {
    if (!isIOSPWA) return
    const options: AddEventListenerOptions = { passive: true }
    window.addEventListener('scroll', scheduleReset, options)
    window.visualViewport?.addEventListener('scroll', scheduleReset, options)
    window.visualViewport?.addEventListener('resize', scheduleReset, options)
}
